import React , {useEffect, useState} from "react";
import {
    Card,
    CardHeader,
    CardBody,
    Row,
    Col,
    Spinner,
    Input,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Form,
    Label,
  } from "reactstrap";
 import Swal from "sweetalert2"
  import Select from 'react-select';
  import { BASE_URL } from "../../utils/constants";
  import axios from "axios";
const InterventionModal = (props)=>{

    const [formData, setFormData] = useState({
        id: 0,
    student_id: "",
    course_id: "",
    teacher_id: "",
    lesson: "",
    notes: "",
    date: '',
    description: "",
    status: "",
      });

      const intialFormData=()=>{
        setFormData({
          id: 0,
          student_id: "",
          course_id: "",
          teacher_id: "",
          lesson: "",
          notes: "",
          date: '',
          description: "",
          status: "",
        });
        setCoursesOptions([])

      }
      
  const [teachersOptions, setTeachersOptions] = useState([]);
  const [courses, setCourses] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [coursesOptions, setCoursesOptions] = useState([]);


  useEffect(() => {

    if (props.interventionId != 0) {


      try {
        axios
          .post(`${BASE_URL}/student/academicintervention/getintervention.php`, { id: props.interventionId })
          .then((res) => {
            setFormData({ ...res.data.data.intervention });
            setTeachers(res.data.data.teachers );
            setCourses(res.data.data.courses );
            const tempTeachers = [];
            res.data.data?.teachers?.forEach((teacher) => {
              tempTeachers.push({ value: teacher.teacherid, label: `${teacher.teachername}  - ${teacher.subject === null ? "" : teacher.subject}` })
            });
            setTeachersOptions(tempTeachers);

            const teacher = res.data.data.teachers?.find((t) => t.teacherid == res.data.data.intervention.teacher_id);
            const tempcourses = [];
            res.data.data.courses?.forEach((course) => {

              if (teacher.subject_id == course.subject_id) {

                tempcourses.push({ value: course.id, label: course.name })
              }
            });
            setCoursesOptions(tempcourses)
            props.setModal(true)

          });
      } catch {
        Swal.fire("Error while grapping AcademicInterventionss!", "", "error");
      }
    }

  }, [props.interventionId])


    const submitHandler = (e)=>{


        
    e.preventDefault();

    if ( !formData.lesson || !formData.teacher_id || !formData.course_id) {
      Swal.fire('Please Select all fields. ', "", 'warning')
      return;
    }

    Swal.fire({
      title: 'Please confirm your request. ',
      showDenyButton: true,
      confirmButtonText: `I confirm`,
      denyButtonText: `Cancel`,
      icon: 'warning',


    }).then((e) => {
      if (e.isConfirmed) {


        Swal.fire({
          html: '<div style="color:blue;"> Loading....... </div>',
          showConfirmButton: false

        })

        axios.post(`${BASE_URL}/student/academicintervention/addintervention.php`, formData).then((res) => {

          console.log(res.data.data)
          if (res.data.data === "success") {
            Swal.fire("Sent Successfully", "", "success").then(() => {
              Swal.close();
              props.setModal(false);
              intialFormData();
              props.setP(!props.p)

            });
          } else {
            Swal.close();
            props.setModal(false);
            intialFormData();
          }

        }).catch(() => {
          Swal.close();
        })


      }
    })

    }

  

    const handleSelectTeacher = (e) => {
        const tempcourses = [];
        const teacher = teachers?.find((t) => t.teacherid == e.value);
    
        courses?.forEach((course) => {
    
          if (teacher.subject_id == course.subject_id) {
    
            tempcourses.push({ value: course.id, label: course.name })
          }
        });
        setCoursesOptions(tempcourses)
        setFormData(prevState => ({ ...prevState, teacher_id: e.value }));
      }


      const handleSelectCourse = (e) => {
        setFormData(prevState => ({ ...prevState, course_id: e.value }));
      }
    

      const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setFormData(prevState => ({ ...prevState, [name]: value }));
      };


    useEffect(()=>{
        try {
            axios
              .post(`${BASE_URL}/student/academicintervention/getstudentinfo.php`)
              .then((res) => {
                console.log(res.data.data);
                const tempTeachers = [];
                res.data.data?.teachers?.forEach((teacher) => {
                  tempTeachers.push({ value: teacher.teacherid, label: `${teacher.teachername}  - ${teacher.subject === null ? "" : teacher.subject}` })
                });
                setTeachersOptions(tempTeachers);
                setCourses(res.data.data.courses);
                setTeachers(res.data.data.teachers);
      
      
              });
          } catch(e) {
            console.log(e);
            Swal.fire("Error while grapping Academic Interventionss!", "", "error");
          }
    },[])

    return(
        <>
         <Modal
          isOpen={props.Modal}
          className="modal-md"
          style={{ width: "50%", height: "50%", top: "20" }}
        >
          <ModalHeader className="bg-info fw-bolder">
            Academic Interventions
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={submitHandler}>
             
              
            <Col md={12}>
                  <div className="form-group">
                    <label htmlFor="teachers">Teachers</label>
                    <Select
                      closeMenuOnSelect={true}
                      options={teachersOptions}
                      onChange={(e) => {
                        handleSelectTeacher(e);
                      }}
                      value={teachersOptions?.filter((teacher) => teacher.value == formData.teacher_id)}
                    />

                  </div>
                </Col>


                
                <Col md={12}>
                  <div className="form-group">
                    <label htmlFor="courses">courses</label>
                    <Select
                      closeMenuOnSelect={true}
                      options={coursesOptions}
                      onChange={(e) => {
                        handleSelectCourse(e);
                      }}
                      value={coursesOptions?.filter((course) => course.value == formData.course_id)}
                    />

                  </div>
                </Col>


                <Col sm={12} >
                  <label>Lesson</label>
                  <Input type="text" onChange={handleChange} rows="2" value={formData.lesson} name="lesson" >
                  </Input>
                </Col>
                <Col sm={12} >
                  <label>Notes</label>
                  <Input type="textarea" style={{border:"solid 1px orange"}} onChange={handleChange} rows={4} value={formData.notes} name="notes" >
                  </Input>
                </Col>

                {formData.status !="Approved" ? (
                     <div style={{ display: "flex", justifyContent: "center" }}>
                     <button
                       style={{ width: "50%" }}
                       className="btn btn-primary m-3"
                       type="submit"
                      
                     >
                       Submit
                     </button>
                   </div>
                ):null}

             
            </Form>
          </ModalBody>
          <ModalFooter>
            <button
              className="btn btn-secondary"
              onClick={() => {intialFormData();props.setModal(false)}}
            >
              Close
            </button>
          </ModalFooter>
        </Modal>


        </>
    )
}


export default  InterventionModal